import { render, staticRenderFns } from "./richtext-block.vue?vue&type=template&id=ac6b3ce8&scoped=true&"
import script from "./richtext-block.vue?vue&type=script&lang=js&"
export * from "./richtext-block.vue?vue&type=script&lang=js&"
import style0 from "./richtext-block.vue?vue&type=style&index=0&id=ac6b3ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6b3ce8",
  null
  
)

export default component.exports